import { render, staticRenderFns } from "./PhotoForm.vue?vue&type=template&id=85d5675a&scoped=true"
import script from "./PhotoForm.vue?vue&type=script&lang=js"
export * from "./PhotoForm.vue?vue&type=script&lang=js"
import style0 from "./PhotoForm.vue?vue&type=style&index=0&id=85d5675a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5675a",
  null
  
)

export default component.exports